import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DxDataGridModule, DxSelectBoxModule } from 'devextreme-angular';
import { DxiItemModule, DxoFilterRowModule, DxoLookupModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { LinkInformationService } from '../../../../services/link-information.service';
import { LinkInformation } from '../../../../interfaces/linkinformation.interface';
import { showErrorSwal } from '@asamco/utils';
import { LinkInformationSettingTemplateBlacklist } from '../../../../interfaces/link-information-setting-template-blacklist.interface';
import { LinkInformationSettingTemplateBlacklistService } from '../../../../services/link-information-setting-template-blacklist.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { SettingTemplate } from '../../../../interfaces/setting-template.interface';
import { SettingTemplateService } from '../../../../services/setting-template.service';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-link-information-setting-blacklist',
	standalone: true,
	imports: [
		CommonModule, DxoFilterRowModule, DxDataGridModule, DxoSelectionModule, DxSelectBoxModule, DxoLookupModule
	],
	templateUrl: './link-information-setting-blacklist.component.html',
	styleUrl: './link-information-setting-blacklist.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkInformationSettingBlacklistComponent implements OnInit {

	linkInformation$: BehaviorSubject<LinkInformation[]> = new BehaviorSubject<LinkInformation[]>([]);
	settingTemplate$: BehaviorSubject<SettingTemplate[]> = new BehaviorSubject<SettingTemplate[]>([]);
	linkInformationSettingTemplateBlacklist$: BehaviorSubject<LinkInformationSettingTemplateBlacklist[]> = new BehaviorSubject<LinkInformationSettingTemplateBlacklist[]>([]);

	filteredSettingTemplate: any[] = [];
	selectedLinkInformationId: number | null = null;


	rowSelections = new Map<number, number>();

	/**
	 *
	 */
	constructor(private linkInformationService: LinkInformationService, private linkInformationSettingTemplateBlacklistService: LinkInformationSettingTemplateBlacklistService, private settingTemplateService: SettingTemplateService) {

	}

	ngOnInit(): void {
		this.loadData();
	}

	customDisplayExpr(item: SettingTemplate) {
		return item ? `[${item.id}] [${item.settingName}] (${item.displayName})` : '[NO SETTING DESCRIPTION SELECTED]';
	}

	onRowSaving(e: DxDataGridTypes.SavingEvent)
	{
		const change: LinkInformationSettingTemplateBlacklist = e.changes[0].data as LinkInformationSettingTemplateBlacklist;

		console.log('saving!')
		this.linkInformationSettingTemplateBlacklistService.create(change).subscribe(e => {
			Swal.fire('Success', 'Data saved successfully', 'success');
			this.getBlacklistInformation();
		}, err => {
			showErrorSwal(err);
		})

		console.log(change)
	}

	onRowRemoving(e: any)
	{

	}

	onRowDeleting(e: DxDataGridTypes.RowRemovedEvent)
	{
		this.linkInformationSettingTemplateBlacklistService.delete(e.data.id).subscribe(e => {
			Swal.fire('Success', 'Data removed successfully', 'success');
			this.getBlacklistInformation();
		}, err => {
			showErrorSwal(err);
		})

	}

	getLinkInformation() {
		this.linkInformationService.getAll()
			.subscribe({
				next: (options) => {
					this.linkInformation$.next(options); // Handle the data received from the server
				},
				error: (error) => {
					showErrorSwal(error);
				}
			});
	}

	getBlacklistInformation() {
		this.linkInformationSettingTemplateBlacklistService.getAll()
			.subscribe({
				next: (options) => {
					this.linkInformationSettingTemplateBlacklist$.next(options);  // Handle the data received from the server
				},
				error: (error) => {
					showErrorSwal(error);
				}
			});
	}

	getSettingTemplates() {
		this.settingTemplateService.getAllSettingTemplates()
		.subscribe({
			next: (options) => {
				this.settingTemplate$.next(options);  // Handle the data received from the server
			},
			error: (error) => {
				showErrorSwal(error);
			}
		});
	}

	loadData() {
		this.getLinkInformation();
		this.getBlacklistInformation();
		this.getSettingTemplates();
	}
}
